var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlay({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_15678",
    "data-name": "Path 15678",
    d: "M18.61,6.11A12.5,12.5,0,1,1,9.771,9.771,12.461,12.461,0,0,1,18.61,6.11Zm5.775,13.017a.593.593,0,0,0,.006-1.031l-8.542-4.932a.6.6,0,0,0-.94.485V23.57h0a.593.593,0,0,0,.888.514l4.3-2.48Z",
    transform: "translate(-5.11 -5.11)",
    fill: "none",
    stroke: "#1d2432",
    strokeWidth: 2,
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlay);
export default __webpack_public_path__ + "static/media/Play.8b4bb683f487c2530e2cd1a1a9e20a8c.svg";
export { ForwardRef as ReactComponent };